module.exports = __webpack_public_path__ + "sferis.png?3b0414522b2d9979eda80dee7011a5e2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sferis.png
// module id = 1013
// module chunks = 2